(() => {
  class JIPredictiveSearch extends HTMLElement {
    connectedCallback(){
      this.input=this.querySelector('[data-ji-search-input]');
      this.results=this.querySelector('[data-ji-search-results]');
      this.form=this.querySelector('form');
      this._controller=null; this._timer=null;
      this.input?.addEventListener('input',()=>this.onInput());
      this.input?.addEventListener('keydown',e=>this.onKey(e));
      this.activeIndex=-1;
    }
    onInput(){clearTimeout(this._timer);const term=this.input.value.trim();if(term.length<2){this.results.innerHTML='';this.input.setAttribute('aria-expanded','false');return}this._timer=setTimeout(()=>this.fetch(term),120)}
    async fetch(term){
      this._controller?.abort(); this._controller=new AbortController();
      const root=(window.JI?.routes?.root||'/').replace(/\/$/,'');
      const url=`${root}/search/suggest?q=${encodeURIComponent(term)}&resources[type]=product,collection,page&resources[limit]=8&section_id=ji-predictive-search`;
      try{const r=await fetch(url,{signal:this._controller.signal,headers:{Accept:'text/html'}});if(!r.ok)throw new Error();const text=await r.text();const doc=new DOMParser().parseFromString(text,'text/html');const content=doc.querySelector('#shopify-section-ji-predictive-search')?.innerHTML||doc.body.innerHTML;this.results.innerHTML=content;this.activeIndex=-1;this.input.setAttribute('aria-expanded',content.trim()?'true':'false')}catch(e){if(e.name!=='AbortError')this.results.innerHTML=''}
    }
    onKey(e){
      if(e.key==='Escape'){this.dispatchEvent(new CustomEvent('ji:search:close',{bubbles:true}));return}
      const items=[...this.results.querySelectorAll('[data-ji-search-result]')];
      if(!items.length)return;
      if(e.key==='ArrowDown'||e.key==='ArrowUp'){
        e.preventDefault();
        this.activeIndex+= e.key==='ArrowDown'?1:-1;
        if(this.activeIndex<0)this.activeIndex=items.length-1;
        if(this.activeIndex>=items.length)this.activeIndex=0;
        items.forEach((el,i)=>{const on=i===this.activeIndex;el.setAttribute('aria-selected',String(on));if(on)el.scrollIntoView({block:'nearest'})});
      } else if(e.key==='Enter'&&this.activeIndex>=0){
        e.preventDefault();items[this.activeIndex].click();
      }
    }
  }
  if(!customElements.get('ji-predictive-search'))customElements.define('ji-predictive-search',JIPredictiveSearch);
  const overlays=()=>[...document.querySelectorAll('[data-ji-search-backdrop],[data-ji-search-panel]')];
  const panel=document.querySelector('[data-ji-search-panel]');
  const drawer=panel&&window.JI?.Drawer?new window.JI.Drawer(panel,{overlay:document.querySelector('[data-ji-search-backdrop]')}):null;
  function open(){drawer?drawer.open():overlays().forEach(o=>{o.classList.add('is-open');o.setAttribute('aria-hidden','false')})}
  function close(){drawer?drawer.close():overlays().forEach(o=>{o.classList.remove('is-open');o.setAttribute('aria-hidden','true')})}
  document.addEventListener('click',e=>{if(e.target.closest('[data-ji-search-open]')){e.preventDefault();open()}if(e.target.closest('[data-ji-search-close]')||e.target.matches('[data-ji-search-backdrop]'))close()});
  document.addEventListener('keydown',e=>{if(e.key==='Escape')close()});
  document.addEventListener('ji:search:close',close);
})();
